import { userNotificationService } from '@/services/user-notification-service'

export const namespaced = false

export const actions = {
  async ['CLEAR_USER_NOTIFICATIONS']({ dispatch }, { orgId, params }) {
    let response
    if (params.allTrials) {
      response = await userNotificationService.markAllAsReadForLoggedInUser(orgId)
    } else {
      response = await userNotificationService.markAsReadForTrial(orgId, params.trialId)
    }
    dispatch('REFRESH_USER_NOTIFICATIONS', {})
    return response.data
  }
}
